import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useRouteSlug } from "@/hooks";
import ModalBFL from "@/components/modal/modal";
import smilePointsIcon from "@/images/loyalty/earnSmilePointsIcon.png";
import birthdayPromotionIcon from "@/images/loyalty/birthdayPromotionIcon.png";
import yellowStar from "@/images/loyalty/loyaltyYellowStar.png";
import crossIcon from "@/images/crossIcon.svg";

import "./style.scss";

const setLoyaltyLocalStorage = (data: {
  initTime?: number;
  timeStamp?: number;
  repeats?: number;
}) => {
  const storeInitTime = localStorage.getItem("loyaltyJoinTimer");
  const parsedTime = storeInitTime && JSON.parse(storeInitTime);

  localStorage.setItem(
    "loyaltyJoinTimer",
    JSON.stringify({ ...parsedTime, ...data })
  );
};

const LoyaltyJoinModal = ({
  repeats,
  loyaltyPopupTimer
}: {
  repeats: number;
  loyaltyPopupTimer: number;
}) => {
  const initTime = loyaltyPopupTimer;
  const routeSlug = useRouteSlug();
  const { t } = useTranslation("loyalty");

  const storeInitTime = localStorage.getItem("loyaltyJoinTimer");
  const parsedTime = storeInitTime && JSON.parse(storeInitTime);
  const [time, setTime] = useState(0);
  const [timerInit, setTimerInit] = useState(false);
  const currentDate = new Date().toDateString();
  const lastDate =
    parsedTime?.timeStamp &&
    new Date(Number(parsedTime?.timeStamp))?.toDateString();

  const closePopUp = () => {
    setTime(initTime);

    Number(parsedTime?.repeats) &&
      setLoyaltyLocalStorage({ repeats: parsedTime?.repeats - 1 });
  };

  useEffect(() => {
    const getInitialTime = () => {
      const now = Date.now();
      const deltaTime = now - (parsedTime?.timeStamp ?? now);

      if (
        !parsedTime ||
        initTime < parsedTime.initTime ||
        parsedTime.initTime - deltaTime < 0
      ) {
        return initTime;
      }

      return parsedTime.initTime - deltaTime;
    };

    const getRepeats = () => {
      if (lastDate && currentDate !== lastDate) {
        return repeats;
      }

      return parsedTime?.hasOwnProperty("repeats")
        ? parsedTime.repeats
        : repeats;
    };

    const shouldInitTimer = (newRepeats: number) => {
      if (lastDate && currentDate !== lastDate) {
        return true;
      }

      return newRepeats > 0;
    };

    const initialization = () => {
      const newTime = getInitialTime();
      const newRepeats = getRepeats();
      const setInitFlag = shouldInitTimer(Number(newRepeats));

      setTime(newTime);
      setTimerInit(setInitFlag);

      setLoyaltyLocalStorage({
        initTime: newTime,
        timeStamp: parsedTime?.timeStamp ?? Date.now(),
        repeats: newRepeats
      });
    };

    initialization();
  }, []);

  useEffect(() => {
    let timer = null;
    if (timerInit && parsedTime?.repeats) {
      const runTimer = () => {
        return setTimeout(() => {
          setTime(time => {
            const newTime = time - 1000;
            setLoyaltyLocalStorage({
              initTime: newTime > 0 ? newTime : 0,
              timeStamp: Date.now()
            });
            return newTime > 0 ? newTime : 0;
          });
        }, 1000);
      };
      timer = runTimer();
    }
    return () => clearTimeout(timer);
  }, [timerInit, time]);

  return (
    <ModalBFL
      overlayClassName="loyaltyJoinModalOverlay"
      showModal={!time}
      modalClass="loyaltyJoinModal"
      closeModal={closePopUp}
    >
      <button className="closeLoyaltyBtn" onClick={closePopUp}>
        <img src={crossIcon} alt="close cross icon" />
      </button>
      <div className="topSection">
        <div className="topSectionContent">
          <span className="welcomeTo">{t("welcomeTo")}</span>
          <h6>{t("smileMore")}</h6>
          <h6>{t("loyaltyProgram")}</h6>
        </div>
      </div>
      <div className="bottomSection">
        <div className="becomeMember">
          <h6>{t("becomeMember")}</h6>
          <p>
            <Trans
              i18nKey="joinAndGetBenefits"
              ns="loyalty"
              components={{ bold: <strong /> }}
            />
          </p>
          <Link
            to={`/${routeSlug}/sign-up/`}
            className="joinNow"
            onClick={closePopUp}
          >
            {t("joinNow")}
          </Link>
          <p className="signIn">
            {t("alreadyMember")}{" "}
            <Link
              to={`/${routeSlug}/authorization/`}
              className="signInLink"
              onClick={closePopUp}
            >
              {t("signIn")}
            </Link>
          </p>
        </div>
        <img src={yellowStar} alt="loyalty yellow star" />
        <h6 className="benefitsHeading">{t("benefits")}</h6>
        <div className="benefitsWrapper">
          <div className="benefitWrapper">
            <div className="benefitIconWrapper">
              <img src={smilePointsIcon} alt="Earn Smile Points Icon" />
            </div>
            <h6>{t("smilePoints")}</h6>
            <p>{t("getSmilePoints")}</p>
          </div>
          <div className="benefitWrapper">
            <div className="benefitIconWrapper">
              <img src={smilePointsIcon} alt="Free Shipping Icon" />
            </div>
            <h6>{t("freeShipping")}</h6>
            <p>{t("getByFreeShipping")}</p>
          </div>
          <div className="benefitWrapper">
            <div className="benefitIconWrapper">
              <img src={birthdayPromotionIcon} alt="Birthday Promotion Icon" />
            </div>
            <h6>{t("birthdayPromotion")}</h6>
            <p>{t("getByBirthday")}</p>
          </div>
        </div>
      </div>
    </ModalBFL>
  );
};

export default LoyaltyJoinModal;
